/**
 * studentsApi.js
 * --------------
 * Production API client for Admission → Student module.
 * 100% Zero Mock Data - Direct FastAPI Integration matching Payroll Architecture.
 */
import api from '../../../../api/client'

export const STATUS_OPTIONS = ['All', 'Active', 'Pending', 'On Hold', 'Inactive']
export const FEE_STATUS_OPTIONS = ['All', 'Paid', 'Partial', 'Unpaid']
export const GENDER_OPTIONS = ['All', 'Male', 'Female', 'Others']
export const DATE_PERIOD_OPTIONS = [
  { value: 'All', label: 'Period' },
  { value: 'currentYear', label: 'Current Year' },
  { value: 'currentMonth', label: 'Current Month' },
  { value: 'currentWeek', label: 'Current Week' },
  { value: 'lastYear', label: 'Last Year' },
  { value: 'lastMonth', label: 'Last Month' },
  { value: 'lastWeek', label: 'Last Week' },
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
]

function buildListParams(params) {
  const q = {}
  if (params.searchField && params.searchField !== 'Name') q.searchField = params.searchField
  if (params.searchText) q.searchText = params.searchText
  if (params.status && params.status !== 'All') q.status = params.status
  if (params.company && params.company !== 'All') q.company = params.company
  if (params.branch && params.branch !== 'All') q.branch = params.branch
  if (params.course && params.course !== 'All') q.course = params.course
  if (params.batch && params.batch !== 'All') q.batch = params.batch
  if (params.scheme && params.scheme !== 'All') q.scheme = params.scheme
  if (params.gender && params.gender !== 'All') q.gender = params.gender
  if (params.counsellor && params.counsellor !== 'All') q.counsellor = params.counsellor
  if (params.feeStatus && params.feeStatus !== 'All') q.feeStatus = params.feeStatus
  if (params.fromDate) q.fromDate = params.fromDate
  if (params.toDate) q.toDate = params.toDate
  if (params.page) q.page = params.page
  if (params.pageSize) q.pageSize = params.pageSize
  return q
}

export async function listStudents(params = {}) {
  const query = buildListParams(params)
  const { data } = await api.get('/admission/students', { params: query })
  if (data && Array.isArray(data.items)) {
    const items = data.items
    items._total_count = data.total_count || items.length
    items._page = data.page || 1
    items._page_size = data.page_size || 10
    items._has_next = data.has_next || false
    return items
  }
  if (Array.isArray(data)) {
    data._total_count = data.length
    data._page = 1
    data._page_size = data.length
    return data
  }
  return []
}

export async function getStudentDetail(studentId) {
  const { data } = await api.get(`/admission/students/${studentId}`)
  return data
}

export async function createStudent(payload) {
  const { data } = await api.post('/admission/students', payload)
  return data
}

export async function updateStudent(studentId, payload) {
  const { data } = await api.put(`/admission/students/${studentId}`, payload)
  return data
}

export async function archiveStudent(studentId) {
  const { data } = await api.patch(`/admission/students/${studentId}/archive`)
  return data
}

export async function deleteStudent(studentId) {
  const { data } = await api.delete(`/admission/students/${studentId}`)
  return data
}

// ── Batch Operations (100% Legacy Parity) ───────────────────────────────────

export async function batchTransferStudents(payload) {
  const { data } = await api.post('/admission/students/batch-transfer', payload)
  return data
}

export async function regenerateRollNumbers(payload) {
  const { data } = await api.post('/admission/students/regenerate-rollno', payload)
  return data
}

export async function sendBatchSMS(payload) {
  const { data } = await api.post('/admission/students/send-sms', payload)
  return data
}

export async function sendBatchEmail(payload) {
  const { data } = await api.post('/admission/students/send-email', payload)
  return data
}

export async function downloadUpdateColumnsTemplate(columnName) {
  const response = await api.get('/admission/students/update-columns/template', {
    params: { column: columnName },
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `Update_Student_${columnName}_Template.xlsx`)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export async function uploadUpdateColumnsFile(file, columnName) {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await api.post(`/admission/students/update-columns?column=${encodeURIComponent(columnName)}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}
